/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {NgModule} from '@angular/core';
import {MdChipList} from './chip-list';
import {MdBasicChip, MdChip, MdChipRemove} from './chip';
import {MdChipInput} from './chip-input';
export class MdChipsModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [],
  exports: [MdChipList, MdChip, MdChipInput, MdChipRemove, MdChipRemove, MdBasicChip],
  declarations: [MdChipList, MdChip, MdChipInput, MdChipRemove,  MdChipRemove, MdBasicChip]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdChipsModule_tsickle_Closure_declarations() {
/** @type {?} */
MdChipsModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdChipsModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
